import { authService } from '../auth/auth.service';
import { logger } from '../../../utils/logger';

export abstract class BaseEndpoint {
  private readonly _baseUrl: string = import.meta.env.VITE_API_BASE_URL;
  protected readonly basePath: string;
  protected readonly baseUrl: string;

  protected constructor(private readonly _basePathSet: string | undefined = undefined) {
    this.basePath = this._basePathSet ? `${this._baseUrl}/${this._basePathSet}` : this._baseUrl;
    this.baseUrl = this._baseUrl;
  }

  protected async getAuthHeaders(): Promise<Record<string, string>> {
    try {
      return await authService.getAuthHeaders();
    } catch (error) {
      logger.error('Failed to get auth headers:', error);
      throw error;
    }
  }
}
